import React from 'react';
import PropTypes from 'prop-types';
import { getSizedImageUrl } from '@shopify/theme-images';

import { getTagValue, formatMoney, getImgSrcsets } from '../../functions';

const RecentItemFurniture = (props) => {
  const { product } = props;
  const measurementSystem = window.getMeasurementSystem();
  const measurements = (typeof product.measurements === 'object')
    ? product.measurements[measurementSystem]
    : product.measurements;

  return (
    <div className="product-card">
      <a href={product.url}>
        <img
          src={product.featured_image && getSizedImageUrl(product.featured_image, '600x')}
          srcSet={product.featured_image && getImgSrcsets(product.featured_image)}
          className="product-card__img bg-grey"
          sizes="(min-width:992px) 33vw, (min-width:768px) 50vw, 100vw"
          alt={product.title}
        />
      </a>
      <h3 className="product-card__title h3 mb-0">
        <a href={product.url}>
          {getTagValue(product.tags, 'range')}
          &nbsp;
          {getTagValue(product.tags, 'size')}
        </a>
      </h3>
      <p className="mb-1 p-small mb-2 color-subtle">
        {Shopify.currency.active + " " + formatMoney(product.price)}
        {product.price_varies ? '+' : ''}
      </p>
      <div className="product-card__bottom">
        <p className="product-card__variant">
          {product.title}
          &nbsp;&mdash;&nbsp;
          {measurements}
          <span className="d-inline-block">
            {/* {product.metafields.dimensions.length}L x
            {product.metafields.dimensions.depth}D x
            {product.metafields.dimensions.height}H */}
          </span>
        </p>
        <p className="product-card__cta"><a href={product.url} className="button button--small">Customise</a></p>
      </div>
    </div>
  );
};

RecentItemFurniture.propTypes = {
  product: PropTypes.shape({
    title: PropTypes.string,
    measurements: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.objectOf(PropTypes.any),
    ]),
    url: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.string),
    featured_image: PropTypes.string,
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    price_varies: PropTypes.bool,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
};

export default RecentItemFurniture;
